import { apiUrlNode } from '@configs/environment';
import axios from 'axios';
import { httpInterceptorsRequestUse, httpInterceptorsResponseUse, paramsSerializer } from '@shared/helpers/httpHelpers';

const httpNodeClient = axios.create({
  baseURL: apiUrlNode,
  headers: { Accept: 'Application/Json' },
  withCredentials: true,
  paramsSerializer,
});

httpInterceptorsRequestUse(httpNodeClient);

httpInterceptorsResponseUse(httpNodeClient);

export default httpNodeClient;
